/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { GET_CREDENTIALS_VTEX } from './graphql';

export function useGetVtexCredentials({ storeId } = {}) {
  const { setLoading, setErrorMessage } = useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    vtexAccountName: '',
    appKey: '',
    appToken: '',
  });
  const [GetVtexCredentials, { loading: apiLoading }] = useLazyQuery(
    GET_CREDENTIALS_VTEX,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function getVtexCredentials(newStoreId) {
    try {
      const res = await GetVtexCredentials({
        variables: { storeId: newStoreId || storeId },
      });
      if (res.data.getVtexCredentials.code === 200) {
        const { vtexAccountName, appKey, appToken } =
          res.data.getVtexCredentials.credentials;
        setCredentials({
          vtexAccountName,
          appKey,
          appToken,
        });
      } else {
        setCredentials({ vtexAccountName: '', appKey: '', appToken: '' });
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  useEffect(() => {
    if (storeId) {
      getVtexCredentials(storeId);
    }
  }, [storeId]);

  return {
    getVtexCredentials,
    credentials,
    setCredentials,
    loading: isLoading,
  };
}
